import {AuthContextProvider} from './allauth/auth'
import Router from './Router'
import {init} from './allauth/init'
import {persistor, store} from "./store";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import { ThemeProvider } from './theme/ThemeProvider';

init()

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeProvider>
                    <AuthContextProvider>
                        <Router/>
                    </AuthContextProvider>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    )
}

export default App
